import { PROMPT_INSTRUCTION_TYPE } from 'src/data/generation';

export const INFINITY_EXTENSION_MODE = {
  promptGeneration: 'promptGeneration',
  variationsGeneration: 'variationsGeneration',
};

export const CANVAS_PROJECT_FORM_EVENT = {
  generationStarted: 'generationStarted',
  backClicked: 'backClicked',
  advancedOptionsToggled: 'advancedOptionsToggled',
};

export const SUGGEST_STRUCTURE_INSTRUCTION_TYPES = [
  PROMPT_INSTRUCTION_TYPE.vocabulary,
  PROMPT_INSTRUCTION_TYPE.format,
  PROMPT_INSTRUCTION_TYPE.formula,
];

export const REWRITE_STRUCTURE_INSTRUCTION_TYPES = [
  PROMPT_INSTRUCTION_TYPE.vocabulary,
  PROMPT_INSTRUCTION_TYPE.format,
];
